import React from 'react';
import { strings } from '../../../resources/strings';
import { Field, FieldType } from '../../../common-components/Field/Field';

export class FormInternalCommunicationValues {
    message?: string;
}

interface IFormInternalCommunicationProps {
    values?: FormInternalCommunicationValues;
    change: (values: FormInternalCommunicationValues) => void;
}

const FormInternalCommunication: React.FC<IFormInternalCommunicationProps> = ({
    values,
    change
}) => {

    return (
        <>
            <Field 
                type={FieldType.TextArea}
                label={strings.Message}
                value={values?.message}
                change={(value) => changeValues({...(values||{}), message: value})}
            />
        </>
    );

    function changeValues(values: FormInternalCommunicationValues) {
        change({...values});
    }
}

export {FormInternalCommunication};